import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";

export interface CreditState {
  isLegderIncorrect: boolean;
  creditToUse: number;
  creditInLedger: number;
}

const initialState: CreditState = {
  isLegderIncorrect: false,
  creditToUse: 0,
  creditInLedger: 0,
};

export const creditState = createSlice({
  name: "credit",
  initialState,
  reducers: {
    setCredit: (state, action: PayloadAction<CreditState>) => {
      return action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.credit;

export const selectCredit = createSelector(selector, (s) => s);

export const { setCredit } = creditState.actions;

export default creditState.reducer;
